// Types
import type { ImageProps } from 'next/image';
import Image from 'next/image';

import clsx from 'clsx';

type SideContentVisualProps = Pick<ImageProps, 'src' | 'width' | 'height'> & {
    className?: string;
};

const SideContentVisual = ({ src, width, height, className }: SideContentVisualProps) => {
    return (
        <div className={clsx('flex h-full w-full flex-col justify-end', className)}>
            <Image
                alt=""
                width={width}
                height={height}
                src={src}
                className="w-full"
                placeholder="blur"
            />
        </div>
    );
};

export default SideContentVisual;
